import { CustomLink } from '../CustomLink/CustomLink';

import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import styles from "./MarketPlaceCard.module.css"
import FleekCoin from "../../asset/icons/fleek-coin-logo.png"

export const MarketPlaceCard = (props)=>{
    const { service: {service_name, logo_url }, starts_from, discount_percentage, vendor_web_path } = props.data;
    
    // Handle Chess.com affiliate redirect
    const handleChessComClick = (e) => {
        e.preventDefault();
        
        
        window.open('https://chess.com/membership?ref_id=372424947', '_blank');
    };
    
    // Check if this is Chess.com
    const isChessCom = vendor_web_path === 'chess.com';
    
    if (isChessCom) {
        return(
            <div className={styles.card} onClick={handleChessComClick} style={{ cursor: 'pointer' }}>
                <div className={styles.imageContainer}>
                    <img className={styles.cardImage} src={logo_url} alt={service_name}
                        loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                    {discount_percentage ? <div className={styles.cardSubTextContainer}>
                        <p className={styles.cardSubText}>UPTO {discount_percentage}% off</p>
                        <img className={styles.FleekCoin} src={FleekCoin} alt="FleekCoin"/>
                    </div> : ''}
                </div>
                <div className={styles.detailContainer}>
                    <div className={styles.detail}>
                        <p className={styles.planName}
                            data-tooltip-id={service_name}
                            data-tooltip-content={service_name}
                            data-tooltip-place='bottom'
                        >{service_name}</p>
                        <p className={styles.planPrice}>{starts_from}</p>
                    </div>
                </div>
                <Tooltip id={service_name} />
            </div>
        );
    }
    
    return(
        <CustomLink to={'/brand/'+ vendor_web_path} className={styles.card}>
            <div className={styles.imageContainer}>
                <img className={styles.cardImage} src={logo_url} alt={service_name}
                        loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                {discount_percentage ? <div className={styles.cardSubTextContainer}>
                    <p className={styles.cardSubText}>UPTO {discount_percentage}% off</p>
                    <img className={styles.FleekCoin} src={FleekCoin} alt="FleekCoin"/>
                </div> : ''}
            </div>
            <div className={styles.detailContainer}>
                <div className={styles.detail}>
                    <p className={styles.planName}
                        data-tooltip-id={service_name}
                        data-tooltip-content={service_name}
                        data-tooltip-place='bottom'
                    >{service_name}</p>
                    <p className={styles.planPrice}>{starts_from}</p>
                </div>
            </div>
            <Tooltip id={service_name} />
        </CustomLink>
    )
}